import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    position: 'relative',
    padding: theme.spacing(1, 3.5, 2, 3.5),
    border: `2px dashed ${theme.palette.grey[300]}`,
    borderRadius: 4,

    '&:hover': {
      '& > button': {
        visibility: 'visible',
      },
    },
  },
  deleteSection: {
    position: 'absolute',
    zIndex: 10,
    top: theme.spacing(-2),
    right: theme.spacing(-1),
    backgroundColor: theme.palette.common.white,

    '&:hover': {
      backgroundColor: theme.palette.common.white,
    },
  },
  sectionContentCount: {
    position: 'absolute',
    backgroundColor: theme.palette.grey[100],
    zIndex: 10,
    right: theme.spacing(2),
  },
  title: {
    backgroundColor: theme.palette.grey[100],
    marginBottom: 0,
    position: 'sticky',
    paddingBottom: theme.spacing(1.75),
    top: theme.spacing(-1),
    width: `calc(100% + ${theme.spacing(1)})`,
    zIndex: 2,

    '& .megadraft-block': {
      padding: 0,
    },

    '& .megadraft-block, & .megadraft-editor': {
      color: theme.palette.grey[800],
      marginTop: theme.spacing(1),

      '& .public-DraftStyleDefault-block': {
        lineHeight: 1.25,
      },

      '& div > span, & .public-DraftEditorPlaceholder-inner': {
        fontFamily: theme.typography.h6.fontFamily,
        fontSize: theme.typography.h5.fontSize,
        fontWeight: theme.typography.h6.fontWeight,
        letterSpacing: 0,
      },
    },
  },
  addAction: {
    textTransform: 'inherit',
    textDecoration: 'underline',
    paddingBottom: 0,
    paddingTop: 0,
  },
  dropStyle: {
    backgroundColor: 'transparent',
    marginBottom: theme.spacing(4),
  },
  contentDialogTextField: {
    padding: theme.spacing(3),
  },
}));
